import React from 'react';
import PropTypes from 'prop-types';

const ArrowRightIcon = ({ className, size, color }) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.29289 16.7071C8.90237 16.3166 8.90237 15.6834 9.29289 15.2929L12.5858 12L9.29289 8.70711C8.90237 8.31658 8.90237 7.68342 9.29289 7.29289C9.68342 6.90237 10.3166 6.90237 10.7071 7.29289L15.4142 12L10.7071 16.7071C10.3166 17.0976 9.68342 17.0976 9.29289 16.7071Z"
            fill={color}
        />
    </svg>
);

ArrowRightIcon.propTypes = {
    className: PropTypes.string,
    size: PropTypes.number,
    color: PropTypes.string,
};

ArrowRightIcon.defaultProps = {
    className: '',
    size: 24,
    color: '',
};

export default ArrowRightIcon;
